<template>
  <div
    id="main1"
    style="height: 800px; width: 100%; margin-top: 10px; margin-left: 100px"
  ></div>
</template>
<script>
export default {
  name: "map",
  data() {
    return {
      myChart: null,
    };
  },
  created() {
    let _this = this;
    this.$http.get("/api/majorlist")
      .then(function (response) {
        // console.log(response.data.data);
        let data = response.data.data;
        for (let i = 0; i < data.length; i++) {
          if (this.majorIndex == data[i].type) {
            this.dataList = data[i];
          }
        }
      })
      .catch(function (error) {
        console.log("出错喽：" + error);
      });
  },
  mounted() {
    this.drawLine();
  },
  methods: {
    drawLine() {},
  },
};
</script>


// WEBPACK FOOTER //
// src/components/map.vue